<template>
  <div class="answer-left">
    <div class="answer-left-title">{{questionTypeStr}}</div>
    <div class="answer-left-content">
      <div class="answer-subject clearfix" >
        <span class="fl">{{parseInt(curQuestionIndex) + 1}}.</span>
        <p class="fl" v-html="$props.curQuestion.title"></p>
      </div>
      <div class="answer-option">
        <ul>
          <li
            :class="[ {'checked': item.checked}]"
            v-for="(item,index) in $props.curQuestion.options"
            :key="`option${index}`"
            @click="optionClick(item)"
          >
            <span class="answer-radio" 
            :class="{
              'answer-radio-user': item.checked,
              'icon-checkbox': parseInt(curQuestion.questionType) === 2,
              'icon-checkbox-checked': parseInt(curQuestion.questionType) === 2 && item.checked
              }"></span>
            <div class="answer-option-text clearfix">
              <span class="fl">{{item.option}}</span>
              <p class="fl" v-html="item.content"></p>
            </div>
          </li>
        <!--  <li class=""><span class="answer-radio"></span><div class="answer-option-text">B.是亚太地区层级最高、领域最广、最具影响力的经济合作机制</div></li>
          <li class=""><span class="answer-radio"></span><div class="answer-option-text">C.本次领导人非正式会议的主题是参与、合作，促进共同繁荣</div></li>
          <li class=""><span class="answer-radio"></span><div class="answer-option-text">D.其运行机制包括领导人非正式会议、部长级会议、高官会、委员会和工作组、秘书处五个层次</div></li>
          -->
        </ul>
      </div>
    </div>
    <div class="answer-button">
      <a href="javascript:;" class="btn-left" @click="$emit('btntopre')">上一题</a>
      <a href="javascript:;" class="btn-right" @click="$emit('btntonext')">下一题</a>
    </div>
  </div>
</template>

<script>
  export default{
    data: function () {
      return {}
    },
    props: {
      curQuestion: Object,
      curQuestionIndex: Number,
      qList: Array
    },
    computed: {
      questionTypeStr: function () {
         const _arr = ['', '单选题', '多选题', '判断题']
         return _arr[parseInt(this.$props.curQuestion.questionType)]
      },
      curQIndex: function () {
        return this.$props.curQuestionIndex
      }
    },
    methods: {
      optionClick: function (item) {
        const questionType = parseInt(this.$props.curQuestion.questionType);
        let _options;

        if (questionType === 2) {
          // 多选题：仅切换当前项的状态
          _options = this.$props.curQuestion.options.map(option => {
            if (option.option === item.option) {
              return { ...option, checked: !option.checked };
            }
            return option;
          });
        } else {
          // 单选题或判断题：只允许一个选项被选中
          _options = this.$props.curQuestion.options.map(option => ({
            ...option,
            checked: option.option === item.option
          }));
        }
        this.$emit('optionsChange', _options)
      }
    }
  }
</script>

<style scoped>
 .answer-left{
   width: 865px;
   float: left;
   background-color: #fff;
   border-radius: 6px;
   min-height: 600px;
 }
 .answer-left-title{
   margin: 15px 20px;
   padding-bottom: 15px;
   border-bottom: 1px solid #e5e5e5;
   font-size: 18px;
 }
 .answer-left-content{
   margin-top: 30px;
 }
 .answer-subject{
   margin-left: 20px;
   margin-right: 20px;
   font-size: 16px;
   color: #252525;
   line-height: 24px;
 }
.answer-subject span{
  margin-right: 10px;
}
.answer-subject p{
  max-width: calc(100% - 36px);
}
 .answer-option{
   margin-left: 20px;
   margin-right: 20px;
   margin-top: 20px;
   overflow: hidden;
 }
 .answer-option ul{
   margin:0;
   padding:0;
 }
 .answer-option ul li{
   list-style-type: none;
   padding: 15px 20px;
   color: #454545;
   float: left;
   width: 785px;
   margin-top:5px;
   margin-bottom: 5px;
 }
 .answer-option ul li:hover{
   background:#e1ffeb;
   border-radius: 6px;
   cursor:pointer;
 }
 .answer-option ul li.checked{
   background:#e1ffeb;
   border-radius: 6px;
   cursor:pointer;
 }
 .answer-option ul li.checked .answer-option-text{
   color:#0AAC50;
   cursor:pointer;
 }
 .answer-option ul li.checked .answer-radio{
   background-image: url(../../../assets/img/icon-option1.png);
   background-repeat: no-repeat;
   background-size: 16px;
   position: absolute;
   display: inline-block;
   vertical-align: middle;
   width: 16px;
   height: 16px;
   margin-top: 3px;
 }
 .answer-option-text{
   font-size: 16px;
   margin-left: 30px;
 }
 .answer-option-text span{
   margin-right: 10px;
 }
 .answer-option-text p{
   max-width: calc(100% - 30px);
 }
 .answer-option ul li:hover .answer-option-text{
   color:#0AAC50;
   cursor:pointer;
 }
 .answer-radio{
   background-image: url(../../../assets/img/icon-option.png);
   background-repeat: no-repeat;
   background-size: 16px;
   position: absolute;
   display: inline-block;
   vertical-align: middle;
   width: 16px;
   height: 16px;
   margin-top:3px;
 }
 .answer-option ul li:hover .answer-radio{
   background-image: url(../../../assets/img/icon-option1.png);
   background-repeat: no-repeat;
   background-size: 16px;
   position: absolute;
   display: inline-block;
   vertical-align: middle;
   width: 16px;
   height: 16px;
   margin-top: 3px;
 }
 .answer-button{
   width: 795px;
   margin-left: 20px;
   margin-right: 20px;
   margin-top: 50px;
   padding-bottom: 50px;
   overflow: hidden;
 }
 .answer-button a.btn-left{
   width: 100px;
   height: 32px;
   border-radius: 4px;
   border: 1px solid #0AAC50;
   color: #0AAC50;
   float: left;
   text-align: center;
   line-height: 32px;
   text-decoration: none;
 }
 .answer-button a.btn-right{
   width: 100px;
   height: 32px;
   border-radius: 4px;
   border: 1px solid #0AAC50;
   color: #0AAC50;
   float: right;
   text-align: center;
   line-height: 32px;
   text-decoration: none;
 }
 .answer-button a:hover.btn-right{
   background:#0AAC50;
   color: #fff;
 }
 .answer-button a:hover.btn-left{
   background:#0AAC50;
   color: #fff;
 }
 .answer-radio.icon-checkbox {
  background-image: url(../../../assets/img/icon-checkbox.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.answer-option ul li.checked .answer-radio.icon-checkbox-checked {
  background-image: url(../../../assets/img/icon-checkbox1.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.answer-option ul li:hover .answer-radio.icon-checkbox {
  background-image: url(../../../assets/img/icon-checkbox1.png);
  background-repeat: no-repeat;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/Exercise/children/question.vue